import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { horarioAsignarLst } from 'src/app/models/horarioAsignarLst';
import { ReporteService } from 'src/app/services/reporte.service';

@Component({
  selector: 'app-historial-ingresos-usuario',
  templateUrl: './historial-ingresos-usuario.component.html',
  styleUrls: ['./historial-ingresos-usuario.component.scss'],
})
export class HistorialIngresosUsuarioComponent implements OnInit {
  public nombreUsuario: string = '';
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public dataInput: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public reporteSvc: ReporteService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<HistorialIngresosUsuarioComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['nombre', 'disciplina', 'fecha', 'resultado'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    // this.inicarFormulario();

    this.nombreUsuario = this.dataInput.nombre;
    this.getListadoHorarios(0, 10);
  }

  getListadoHorarios(page: number, numReg: number) {
    this.reporteSvc
      .getIngresosUsuario(page, numReg, this.dataInput.id)
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<any>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getListadoHorarios(event.pageIndex, event.pageSize);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
